import { ReactElement } from 'react';
import { NavLink } from '@localstack/ui';
import { buildRoute } from '@localstack/services';

import { LambdaRoutes } from '../../types';

interface Props {
  routes: LambdaRoutes;
  functionName: string | undefined;
  showScalingConfigTab?: boolean;
}

export const FunctionTabs = ({ routes, functionName, showScalingConfigTab = false }: Props): ReactElement => {
  const functionNameHasVersion = functionName?.includes(':');
  const functionNameWithoutVersion = functionNameHasVersion ? functionName?.split(':')[0] : functionName;
  return (
    <>
      <NavLink to={buildRoute(routes.RESOURCES_LAMBDA_FUNCTION, { name: functionName })} end>
        Details
      </NavLink>
      <NavLink
        target="_blank"
        to={buildRoute(routes.RESOURCES_CLOUDWATCH_GROUP_EVENTS, {
          logGroupName: `/aws/lambda/${functionNameWithoutVersion}`,
        })}
        end
      >
        Logs
      </NavLink>
      <NavLink to={buildRoute(routes.RESOURCES_LAMBDA_FUNCTION_INVOKE, { name: functionName })} end>
        Invoke
      </NavLink>
      {showScalingConfigTab && (
        <NavLink to={buildRoute(routes.RESOURCES_LAMBDA_FUNCTION_SCALING_CONFIG, { name: functionName })} end>
          Scaling Config
        </NavLink>
      )}
    </>
  );
};
